import {useEffect, useRef, useState} from 'react';

/**
 * 倒计时展示 hook（纯 UI 展示，不触发状态迁移）
 * @param expireAt 二维码过期时间戳（Unix 秒），null 时不展示
 * @returns "MM:SS" 格式字符串，已过期或未传入返回 null
 */
export function useCountdownDisplay(expireAt: number | null): string | null {
    const [display, setDisplay] = useState<string | null>(null);
    const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        if (!expireAt) {
            setDisplay(null);
            return () => {};
        }

        const update = () => {
            const remainMs = expireAt * 1000 - Date.now();

            if (remainMs <= 0) {
                setDisplay(null);
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                }
                return;
            }

            const totalSec = Math.ceil(remainMs / 1000);
            const mm = String(Math.floor(totalSec / 60)).padStart(2, '0');
            const ss = String(totalSec % 60).padStart(2, '0');
            setDisplay(`${mm}:${ss}`);
        };

        update();
        timerRef.current = setInterval(update, 1000);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [expireAt]);

    return display;
}
